import Vue from 'vue';
import Vuex from 'vuex';
import {
  saveAuthToCookie,
  saveUserToCookie,
  //saveTenantToCookie,
  getAuthFromCookie,
  getUserFromCookie,
  getTenantFromCookie,
  deleteCookie,
} from '@/utils/cookies';

import { certificate, logoutUser } from '@/api/auth';
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    username: getUserFromCookie() || '',
    token: getAuthFromCookie() || '',
    tenant: getTenantFromCookie() || '',
    redirectUrl: '',
  },
  getters: {
    isLogin(state) {
      console.log('getter ::: ' + state.token);
      console.log('getter ::: ' + state.token !== '');

      return state.token !== '';
    },
    tenantKey(state) {
      return state.tenant;
    },
    redirectUrl(state) {
      return state.redirectUrl;
    },
  },
  mutations: {
    setUsername(state, username) {
      state.username = username;
      saveUserToCookie(username);
    },
    setToken(state, token) {
      state.token = token;
      saveAuthToCookie(token);
    },
    setTenant(state, tenant) {
      state.tenant = tenant;
    },
    setRedirectUrl(state, redirectUrl) {
      state.redirectUrl = redirectUrl;
    },
    clearRedirectUrl(state) {
      state.redirectUrl = '';
    },
    clearUsername(state) {
      state.username = '';
    },
    clearToken(state) {
      state.token = '';
    },

    logout(state) {
      console.log('logout');
      //   console.log(getAuthFromCookie());
      state.token = '';

      deleteCookie('authorization');
      //   console.log(getAuthFromCookie());
      //   console.log('-----------------');
      //   window.app.$router.push('/login/isust');
      //   console.log('-----------------');
    },
  },
  actions: {
    async LOGOUT({ commit }, tenantKey) {
      try {
        await logoutUser(tenantKey);
      } catch (e) {
        console.log('logout error:', e);
      }
      commit('logout');
      window.app.$router.push('/login/' + tenantKey);
    },
    async hasAuthorization({ commit }, tenantKey) {
      console.log('hasAuthorization :: ');
      try {
        await certificate(tenantKey);
        //console.log(data);
        return true;
      } catch (error) {
        console.log(error);
        commit('logout');

        window.app.$router.push({
          name: 'login',
          params: { tenantKey: tenantKey },
        });

        return false;
      }
    },
    /*
    async LOGIN({ commit }, v) {
      const { data } = await loginUser('isust', v);
      console.log(data);
      commit('setUsername', data.user.username);
      commit('setToken', data.token);
      //this.logMessage = `${data.user.username} 님 환영합니다.`;
      saveAuthToCookie(data.token);
      saveUserToCookie(data.user.username);
      return data;
    },
    */
  },
});
